import { styled } from '@mui/material';
import { CoreDialogTitle } from '@youscience/core';

export const sxStyles = {
  dialog: {
    maxHeight: '100%',

    '.MuiPaper-root': {
      width: '100%',
    },
  },
  contentInner: {
    maxWidth: '796px',
    width: '100%',
  },
  contentTitle: {
    marginTop: '2.5rem',
    lineHeight: '42px',
  },
  description: {
    marginTop: '1rem',
    marginBottom: '2.5rem',
  },
  fieldsWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  fullName: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1.5rem',
  },
  checkboxGroup: {
    margin: '1rem 0',

    label: {
      width: '50%',
      marginRight: 0,
    },
  },
};

export const StyledDialogTitle = styled(CoreDialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '1.5rem',
  fontSize: '1.125rem',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,
}));
